import React, { FunctionComponent, ReactNode } from "react";
import { Button as IBIButton } from "./styles";
import Loading from "./Loading";
import { getHoverStyle, getStyle, size as sizeType, defaultStyle } from "./helpers";
import { variant as variantType } from "./buttonVariants";

export interface ButtonProps {
    children: ReactNode;
    loading?: boolean;
    size?: sizeType;
    variant?: variantType;
    disabled?: boolean;
    onClick?: (...args: unknown[]) => unknown;
    title?: string;
    className?: string;
    activeButton?: boolean;
    caseChanged?: boolean;
    type?: "button" | "submit" | "reset";
    id?: string;
}

export const Button: FunctionComponent<ButtonProps> = ({
    onClick,
    size,
    children,
    variant,
    disabled,
    loading,
    title,
    activeButton,
    type,
    ...rest
}) => {
    /*
     *  We need this as typescript currently doesn't support default props so we need to check
     *  if variant,size are being passed or else typescript marks them undefined
     *  even if default props are passed
     */
    const defaultHoverStyle = {
        backgroundColor: "#FFFFFF",
        color: "#000000"
    };

    // This is the default style when button is rendered on dom
    const style = variant ? getStyle(variant, size, disabled) : defaultStyle;

    // Hover Style of button
    const hoverStyle = variant ? getHoverStyle(variant) : defaultHoverStyle;

    return (
        <IBIButton
            activeButton={activeButton}
            as="button"
            disabled={disabled}
            generalStyle={style}
            hoverStyle={hoverStyle}
            title={title}
            type={type}
            onClick={onClick}
            {...rest}
        >
            <div className="text-truncate children">{loading ? <Loading /> : children}</div>
        </IBIButton>
    );
};

Button.defaultProps = {
    caseChanged: true,
    disabled: false,
    loading: false,
    size: "lg",
    title: "",
    type: "button",
    variant: "primary"
};
